import { useEffect, useState } from "react";
import { Globe, X } from "lucide-react";
import { LANG_CODES, tFor, useLang } from "@/i18n";

const API = process.env.REACT_APP_BACKEND_URL;
const GEO_LANG = { DE: "de", AT: "de", CH: "de", LI: "de", FR: "fr", BE: "fr", LU: "fr", MC: "fr", IT: "it", ES: "es", RO: "ro", MD: "ro" };

async function geoLang() {
  const cached = sessionStorage.getItem("hm-geo-lang");
  if (cached !== null) return cached || null;
  try {
    const r = await fetch(`${API}/api/geo`);
    const d = await r.json();
    const l = d.lang || GEO_LANG[d.country_code] || "";
    sessionStorage.setItem("hm-geo-lang", l);
    return l || null;
  } catch {
    return null;
  }
}

export default function LangSuggest() {
  const { lang, setLang } = useLang();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    let alive = true;
    const until = Number(localStorage.getItem("hm-lang-suggest-until") || 0);
    if (until > Date.now()) return undefined;
    const stored = localStorage.getItem("hm-lang-pref");
    const browserLangs = (navigator.languages || [navigator.language || ""]).map((l) => l.slice(0, 2).toLowerCase());
    const browser = browserLangs.find((l) => LANG_CODES.includes(l)) || null;
    if (stored) { setTarget(stored !== lang ? stored : null); return undefined; }
    if (browser) {
      if (lang === "ro" && browserLangs.includes("ro")) { setTarget(null); return undefined; }
      setTarget(browser !== lang ? browser : null);
      return undefined;
    }
    geoLang().then((g) => { if (alive) setTarget(g && g !== lang ? g : null); });
    return () => { alive = false; };
  }, [lang]);

  if (!target) return null;

  const dismiss = () => {
    localStorage.setItem("hm-lang-suggest-until", String(Date.now() + 30 * 24 * 3600 * 1000));
    setTarget(null);
  };

  return (
    <div className="border-b border-white/10 bg-[#0b1220] text-white" data-testid="lang-suggest">
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-3 px-5 py-3 sm:px-8">
        <p className="flex items-center gap-3 text-[14px] text-white/85">
          <Globe className="h-4 w-4 shrink-0 text-gold" aria-hidden />
          {tFor(target, "ls_text")}
        </p>
        <div className="flex items-center gap-3">
          <button
            onClick={() => { dismiss(); setLang(target); }}
            data-testid="lang-suggest-accept"
            className="inline-flex items-center gap-2 bg-white px-4 py-2 text-[13px] font-semibold text-[#0b1220] transition-colors hover:bg-gold"
          >
            {tFor(target, "ls_btn")} →
          </button>
          <button onClick={dismiss} data-testid="lang-suggest-close" aria-label={tFor(target, "ls_close")} className="p-1 text-white/50 transition-colors hover:text-white">
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
